<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import DicaDoCampo from 'dashboard/components-next/captain/pageComponents/assistant/DicaDoCampo.vue';
import ToolSelectionPanel from 'dashboard/components-next/captain/pageComponents/assistant/tabs/ToolSelectionPanel.vue';

// Aba "O que pode fazer" (fatia 3 das 5 abas, 02/09/2026): as ações com nome
// humano, o que fazem e um exemplo; pacotes de nicho; criar ação própria; e o
// que ela anota na ficha do cliente.
const props = defineProps({
  assistantId: { type: Number, required: true },
  assistant: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const route = useRoute();

const rota = (name, query) => ({
  name,
  params: { accountId: route.params.accountId, assistantId: props.assistantId },
  ...(query ? { query } : {}),
});
const regrasDeCampo = computed(
  () => props.assistant?.config?.custom_field_rules || []
);
</script>

<template>
  <div class="flex flex-col gap-8" data-testid="aba-o-que-pode-fazer">
    <section class="flex flex-col gap-4">
      <header class="flex flex-col items-start gap-2">
        <h2
          class="flex items-center gap-2 text-base font-medium text-n-slate-12"
        >
          {{ t('CAPTAIN.O_QUE_PODE_FAZER.ACOES.TITULO') }}
          <DicaDoCampo termo="ACAO" />
        </h2>
        <p class="text-sm text-n-slate-11">
          {{ t('CAPTAIN.O_QUE_PODE_FAZER.ACOES.DESCRICAO') }}
        </p>
      </header>
      <ToolSelectionPanel :assistant-id="assistantId" />
      <router-link
        :to="rota('captain_tools_index')"
        class="text-sm font-medium text-n-brand"
        data-testid="criar-acao"
      >
        {{ t('CAPTAIN.O_QUE_PODE_FAZER.ACOES.CRIAR') }}
      </router-link>
    </section>

    <span class="h-px w-full bg-n-weak" />

    <section
      class="flex flex-col gap-3 rounded-2xl border border-n-weak p-4"
      data-testid="campos-da-ia"
    >
      <h2 class="text-base font-medium text-n-slate-12">
        {{ t('CAPTAIN.O_QUE_PODE_FAZER.CAMPOS.TITULO') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ t('CAPTAIN.O_QUE_PODE_FAZER.CAMPOS.DESCRICAO') }}
      </p>
      <ul
        v-if="regrasDeCampo.length"
        class="m-0 flex list-disc flex-col gap-1 pl-5 text-sm text-n-slate-12"
      >
        <li v-for="regra in regrasDeCampo.slice(0, 5)" :key="regra.key">
          {{ regra.key }}: {{ regra.when }}
        </li>
      </ul>
      <p v-else class="m-0 text-sm text-n-slate-11">
        {{ t('CAPTAIN.O_QUE_PODE_FAZER.CAMPOS.VAZIO') }}
      </p>
      <router-link
        :to="rota('captain_assistants_field_rules_index')"
        class="text-sm font-medium text-n-brand"
      >
        {{
          regrasDeCampo.length
            ? t('CAPTAIN.O_QUE_PODE_FAZER.CAMPOS.EDITAR')
            : t('CAPTAIN.O_QUE_PODE_FAZER.CAMPOS.ESCOLHER')
        }}
      </router-link>
    </section>
  </div>
</template>
